import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { MessageSquareQuote, X } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : "");

export function ManagerNotes() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notes").then((r) => setItems(r.data.items.filter((n) => !n.manager_note.read))).catch(() => {}); }, []);
  const dismiss = async (sid) => {
    setItems((s) => s.filter((n) => n.id !== sid));
    try { await api.post(`/notes/${sid}/read`); } catch { /* best effort */ }
  };
  if (!items.length) return null;
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="rounded-3xl border border-cyan-200 bg-gradient-to-br from-cyan-50 via-white to-white p-5 shadow-[0_4px_20px_-4px_rgba(6,182,212,0.18)]" data-testid="manager-notes">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-cyan-700"><MessageSquareQuote className="w-4 h-4" /> From your manager</div>
      <div className="mt-3 space-y-3">
        {items.map((n) => (
          <div key={n.id} className="flex items-start gap-3 rounded-2xl bg-white border border-slate-200/80 p-3.5" data-testid={`manager-note-${n.id}`}>
            {n.persona_avatar && <img src={n.persona_avatar} alt="" className="w-10 h-10 rounded-xl object-cover object-top shrink-0" />}
            <div className="flex-1 min-w-0">
              <div className="text-xs text-slate-500">{n.manager_note.by_name} on your <span className="font-semibold text-slate-700">{n.persona_title}</span> call ({n.rating}/100 · {fmt(n.ended_at)})</div>
              <p className="text-sm text-slate-900 mt-1 leading-relaxed">“{n.manager_note.text}”</p>
              <Link to={`/app/roleplay?session=${n.id}`} className="inline-block mt-2 text-xs font-semibold text-cyan-700 hover:underline" data-testid={`manager-note-open-${n.id}`}>Open that scorecard →</Link>
            </div>
            <button onClick={() => dismiss(n.id)} className="text-slate-400 hover:text-slate-700 shrink-0" title="Mark as read" data-testid={`manager-note-dismiss-${n.id}`}><X className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
